import { render, staticRenderFns } from "./fundChangeRecord.vue?vue&type=template&id=043fa578&"
import script from "./fundChangeRecord.vue?vue&type=script&lang=js&"
export * from "./fundChangeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports